import { PublishedResults } from '../../../components/results/shared/PublishedResults';

export default function ParentViewTest() {
  return <PublishedResults assessmentType="test" audience="parent" />;
}
